import type { EmployeeDocumentResponse } from '../reports/types';

export type { EmployeeDocumentResponse };

export interface UploadDocumentInput {
  file: File;
  documentType: number;
  documentName: string;
  /** Required when the type is Other. */
  customTypeDescription: string | null;
  /** yyyy-mm-dd, optional: not every document expires. */
  expiryDate: string | null;
}

/** What the file picker enforces before anything is sent. The server checks again (extension, content type, leading bytes, size): this only gives an
 * immediate, specific message. Mirrors EPN.Employees.Api's `DocumentValidation`. */
export const MAX_DOCUMENT_BYTES = 10 * 1024 * 1024;
export const ACCEPTED_DOCUMENT_TYPES: Record<string, string> = {
  'application/pdf': 'PDF',
  'image/png': 'PNG',
  'image/jpeg': 'JPEG',
};
export const ACCEPT_ATTRIBUTE = '.pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg';

export function checkFile(file: File): string | null {
  if (file.size <= 0) return 'This file is empty.';
  if (file.size > MAX_DOCUMENT_BYTES) return `This file is larger than ${MAX_DOCUMENT_BYTES / 1024 / 1024} MB.`;
  if (!ACCEPTED_DOCUMENT_TYPES[file.type]) return 'Only PDF, PNG or JPEG files can be uploaded.';
  return null;
}

export function formatFileSize(bytes: number): string {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}
